import StorageLogger from '@voicenter-team/socketio-storage-logger'
import { loggerConnectOptions } from '@/enum/socketConnectionConfig'

export default {
    install(Vue) {
        const loggerUrl = process.env.VUE_APP_LOGGER_API_URL

        if (!loggerUrl) {
            console.error('Logger URL is not provided!')
            return
        }

        const config = {
            url: loggerUrl,
            socketOptions: {
                ...loggerConnectOptions
            },
            loggerOptions: {
                system: 'realtime-dashboard',
                logToConsole: true,
                overloadGlobalConsole: false,
                socketEmitInterval: 10000
            }
        }

        const logger = new StorageLogger(config)
        Vue.prototype.$logger = logger
    }
}
